import React, {useState, useEffect} from 'react';
import {useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
//import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, ViberShareButton, WhatsappShareButton} from "react-share";
import * as reactShare from "react-share";

const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  smallBox: {
    minWidth: '36px'
  },
}));

const ShareDialog = ({ onClose, selectedValue, open, newsId } ) => {
    const classes = useStyles();

    const history = useHistory();
    const pathname = history?.location?.pathname;

    const shareUrl = `https://nuins.io/news-details/${newsId}`

    const shareMedia = ['Facebook', 'Linkedin', 'Twitter', 'Viber', 'Whatsapp'];

    const handleClose = () => {
      onClose(selectedValue);
    };
  
    const handleListItemClick = (value) => {
      onClose(value);
    };
  
    return (
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
        <DialogTitle id="simple-dialog-title">Share width</DialogTitle>
        <List>
          {shareMedia.map((media, i) => {
            const buttonName = `${media}ShareButton`;
            const iconName = `${media}Icon`;
            const ShareButton = reactShare[buttonName];
            const ShareIcon = reactShare[iconName];
            
            const getChildren = () => {
              return <div style={{display: 'flex'}}>
                <ListItemAvatar className={classes.smallBox}>
                <Avatar className={classes.small}>
                  <ShareIcon size={32} round={true} />
                </Avatar >
              </ListItemAvatar>
              <ListItemText primary={media} />
              </div>
            }

            return <ListItem button onClick={() => handleListItemClick()} key={i+1}>
                     <ShareButton  url={shareUrl} children={getChildren()}/>
                   </ListItem>
          })}
  
        </List>
      </Dialog>
    );
  }
  export default ShareDialog;